module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page close-picker"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 offset-md-1"
  }, [_c('i', {
    staticClass: "icon fa fa-arrow-left",
    staticStyle: {
      "margin-top": "25px",
      "margin-bottom": "25px"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_c('span', {
    staticClass: "ml-1 backLabel",
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.bck')))])]), _vm._v(" "), _c('div', {
    staticClass: "panel21 panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "content-block labelAccordionForm"
  }, [_c('img', {
    staticClass: "formIcon formIconSmall",
    attrs: {
      "src": require("../../assets/static/images/icons/paperclip.png")
    }
  }), _vm._v("\n                  " + _vm._s(_vm.$t('attachments.create_refund')) + "\n              ")])]), _vm._v(" "), _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.formsSubTitle.gnrl')) + "\n                        "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content hasDatePicker"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputLabel": _vm.createRefund_Object,
      "placeholderValue": _vm.createRefund_Object
    },
    model: {
      value: (_vm.remittanceInformation),
      callback: function($$v) {
        _vm.remittanceInformation = $$v
      },
      expression: "remittanceInformation"
    }
  }), _vm._v(" "), _c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputType": "date",
      "inputLabel": _vm.$t('attachments.issue_date'),
      "placeholderValue": _vm.$t('common.datepicker_format_date')
    },
    model: {
      value: (_vm.dateOfIssue),
      callback: function($$v) {
        _vm.dateOfIssue = $$v
      },
      expression: "dateOfIssue"
    }
  })], 1)])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.formsSubTitle.rcpt')) + "\n                        "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "createInvoicePicker col-sm-4",
    class: _vm.colorBottomButton
  }, [_c('a', {
    staticClass: "link open-picker button button-round",
    attrs: {
      "href": "#",
      "data-picker": ".contactListPicker"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.slct_ctcts')) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputLabel": _vm.createRefund_FullName,
      "placeholderValue": _vm.createRefund_FullName
    },
    model: {
      value: (_vm.debtorName),
      callback: function($$v) {
        _vm.debtorName = $$v
      },
      expression: "debtorName"
    }
  }), _vm._v(" "), _c('form-write-group-label-input', {
    attrs: {
      "inputLabel": _vm.createRefund_Address,
      "placeholderValue": _vm.createRefund_Address
    },
    model: {
      value: (_vm.debtorAddress),
      callback: function($$v) {
        _vm.debtorAddress = $$v
      },
      expression: "debtorAddress"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": _vm.createRefund_City,
      "placeholderValue": _vm.createRefund_City
    },
    model: {
      value: (_vm.debtorCodeAddress),
      callback: function($$v) {
        _vm.debtorCodeAddress = $$v
      },
      expression: "debtorCodeAddress"
    }
  }), _vm._v(" "), _c('form-write-group-label-input', {
    attrs: {
      "inputLabel": _vm.createRefund_Zipcode,
      "placeholderValue": _vm.createRefund_Zipcode
    },
    model: {
      value: (_vm.debtorZipCode),
      callback: function($$v) {
        _vm.debtorZipCode = $$v
      },
      expression: "debtorZipCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": _vm.createRefund_Country,
      "placeholderValue": _vm.createRefund_Country
    },
    model: {
      value: (_vm.debtorCountry),
      callback: function($$v) {
        _vm.debtorCountry = $$v
      },
      expression: "debtorCountry"
    }
  })], 1)])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.formsSubTitle.sndr')) + "\n                        "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputLabel": _vm.createRefund_Identifier,
      "placeholderValue": _vm.createRefund_Identifier
    },
    model: {
      value: (_vm.creditorIdentifier),
      callback: function($$v) {
        _vm.creditorIdentifier = $$v
      },
      expression: "creditorIdentifier"
    }
  }), _vm._v(" "), _c('form-write-group-label-input', {
    attrs: {
      "inputLabel": _vm.createRefund_Registrynumber,
      "placeholderValue": _vm.createRefund_Registrynumber
    },
    model: {
      value: (_vm.rcs),
      callback: function($$v) {
        _vm.rcs = $$v
      },
      expression: "rcs"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": _vm.createRefund_TVAnumber,
      "placeholderValue": _vm.createRefund_TVAnumber
    },
    model: {
      value: (_vm.identifierTVA),
      callback: function($$v) {
        _vm.identifierTVA = $$v
      },
      expression: "identifierTVA"
    }
  }), _vm._v(" "), _c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputLabel": _vm.createRefund_Address,
      "placeholderValue": _vm.createRefund_Address
    },
    model: {
      value: (_vm.creditorAddress),
      callback: function($$v) {
        _vm.creditorAddress = $$v
      },
      expression: "creditorAddress"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputLabel": _vm.createRefund_City,
      "placeholderValue": _vm.createRefund_City
    },
    model: {
      value: (_vm.creditorCodeAddress),
      callback: function($$v) {
        _vm.creditorCodeAddress = $$v
      },
      expression: "creditorCodeAddress"
    }
  }), _vm._v(" "), _c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputLabel": _vm.createRefund_Zipcode,
      "placeholderValue": _vm.createRefund_Zipcode
    },
    model: {
      value: (_vm.creditorZipCode),
      callback: function($$v) {
        _vm.creditorZipCode = $$v
      },
      expression: "creditorZipCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputLabel": _vm.createRefund_Country,
      "placeholderValue": _vm.createRefund_Country
    },
    model: {
      value: (_vm.creditorCountry),
      callback: function($$v) {
        _vm.creditorCountry = $$v
      },
      expression: "creditorCountry"
    }
  }), _vm._v(" "), _c('form-write-group-label-input', {
    attrs: {
      "inputLabel": _vm.createRefund_LegalForm,
      "placeholderValue": _vm.createRefund_LegalForm
    },
    model: {
      value: (_vm.legalForm),
      callback: function($$v) {
        _vm.legalForm = $$v
      },
      expression: "legalForm"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputType": "number",
      "inputLabel": _vm.$t('common.shr_cptl') + ' (€)',
      "placeholderValue": _vm.createRefund_amount
    },
    model: {
      value: (_vm.amountOfCapital),
      callback: function($$v) {
        _vm.amountOfCapital = $$v
      },
      expression: "amountOfCapital"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-5 col-sm-2 ",
    class: _vm.colorBottomButton
  }, [_c('label', {
    staticClass: "inputFileButton attachementCreateInvoiceButtonLength",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "for": "fileLogo"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.lgo')))])]), _vm._v(" "), _c('input', {
    staticClass: "inputfile",
    attrs: {
      "type": "file",
      "name": "fileLogo",
      "id": "fileLogo"
    },
    on: {
      "change": _vm.uploadFile
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.logoName),
      expression: "logoName"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "filename",
      "placeholder": _vm.createRefund_Choosefile,
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.logoName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.logoName = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.formsSubTitle.rfnd')) + "\n                        "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content hasDatePicker"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputType": "date",
      "inputLabel": _vm.$t('attachments.blng_date'),
      "placeholderValue": _vm.$t('common.datepicker_format_date')
    },
    model: {
      value: (_vm.dateOfSale),
      callback: function($$v) {
        _vm.dateOfSale = $$v
      },
      expression: "dateOfSale"
    }
  }), _vm._v(" "), _c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputLabel": _vm.createRefund_Refundnumber,
      "placeholderValue": _vm.createRefund_Refundnumber
    },
    model: {
      value: (_vm.identifier),
      callback: function($$v) {
        _vm.identifier = $$v
      },
      expression: "identifier"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputType": "number",
      "inputLabel": _vm.createRefund_amount,
      "placeholderValue": _vm.createRefund_amount
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  }), _vm._v(" "), _c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputType": "number",
      "inputLabel": _vm.$t('common.ovrpymnt'),
      "placeholderValue": _vm.$t('common.ovrpymnt')
    },
    model: {
      value: (_vm.overpayment),
      callback: function($$v) {
        _vm.overpayment = $$v
      },
      expression: "overpayment"
    }
  })], 1), _vm._v(" "), (_vm.type === '1') ? _c('div', {
    staticClass: "row",
    on: {
      "click": function($event) {
        return _vm.hideBlock($event)
      }
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "inputType": "number",
      "inputLabel": _vm.$t('common.crrct_amnt'),
      "placeholderValue": _vm.createRefund_Correctamount
    },
    model: {
      value: (_vm.newAmount),
      callback: function($$v) {
        _vm.newAmount = $$v
      },
      expression: "newAmount"
    }
  })], 1) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 offset-md-9"
  }, [_c('button', {
    staticClass: "milkyBlockBlack button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.createPDF('cloud')
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-save"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.sve')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "picker-modal contactListPicker"
  }, [_c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "toolbar-inner"
  }, [_c('div', {
    staticClass: "left"
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('a', {
    staticClass: "close-picker",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.contactListPickerCloseButton
    }
  }, [_vm._v(_vm._s(_vm.$t('common.close_label')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "picker-modal-inner scrollablePicker"
  }, [_c('form', {
    staticClass: "searchbar searchbar-init",
    attrs: {
      "data-search-list": ".contactRecipientList",
      "data-search-in": ".item-title"
    }
  }, [_c('div', {
    staticClass: "searchbar-input"
  }, [_c('input', {
    attrs: {
      "type": "search",
      "placeholder": _vm.createRefund_Search
    }
  }), _c('a', {
    staticClass: "searchbar-clear",
    attrs: {
      "href": "#"
    }
  })]), _c('a', {
    staticClass: "searchbar-cancel",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cncl')))])]), _vm._v(" "), _c('div', {
    staticClass: "list-block contactRecipientList"
  }, [_c('f7-list', {
    staticClass: "contactRecipientList",
    attrs: {
      "contacts": ""
    }
  }, _vm._l((this.contactSelectionList), function(group, key) {
    return _c('f7-list-group', {
      key: key
    }, [_c('f7-list-item', {
      attrs: {
        "title": key,
        "group-title": ""
      }
    }), _vm._v(" "), _vm._l((group), function(contact) {
      return _c('li', {
        attrs: {
          "value": contact.id
        }
      }, [_c('label', {
        staticClass: "label-radio item-content",
        on: {
          "click": _vm.contactListPickerCloseButton
        }
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": "countryPickerRadio"
        },
        domProps: {
          "value": contact.id
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "item-inner"
      }, [_c('div', {
        staticClass: "item-title"
      }, [_vm._v(_vm._s(contact.name))])])])])
    })], 2)
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1d528a4e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d528a4e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/attachments/CMAttachmentsCreateRefund.vue
// module id = 2355
// module chunks = 2